import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
export var SwapQuoteType;
(function (SwapQuoteType) {
    SwapQuoteType["EXACT_BASE_TO_QUOTE"] = "ExactBaseToQuote";
    SwapQuoteType["BASE_TO_EXACT_QUOTE"] = "BaseToExactQuote";
    SwapQuoteType["EXACT_QUOTE_TO_BASE"] = "ExactQuoteToBase";
    SwapQuoteType["QUOTE_TO_EXACT_BASE"] = "QuoteToExactBase";
})(SwapQuoteType || (SwapQuoteType = {}));
export const SwapQuoteTypeSchema = Type.Enum(SwapQuoteType);
/**
 * Parses a string into a SwapQuoteType enum value
 * @param quoteType - The quote type string to parse
 * @returns The parsed SwapQuoteType value
 * @throws {Error} If the quote type string is invalid
 */
export const parseSwapQuoteType = (quoteType) => {
    try {
        return Value.Parse(SwapQuoteTypeSchema, quoteType);
    }
    catch {
        throw new Error(`Invalid swap quote type: ${quoteType}. Expected one of: ${Object.values(SwapQuoteType).join(', ')}.`);
    }
};
//# sourceMappingURL=swap-quote-type.js.map